import React from "react";
import { CaseStageEnum } from "../../../../../src/api/caseStages";
import {useAppSelector } from "../../../../../src/app/store";
import { selectStageConfigByStage } from "../../logic/slice";
import WorkflowStageBanner from "../../../../../src/features/stageWorkflow/components/WorkflowStageBanner";
import WorkflowStageInfoBanner from "../../../../../src/features/stageWorkflow/components/WorkflowStageInfoBanner";
import { selectCurrentCaseStage } from "../../../../../src/features/caseinfo/logic/Slice";
import { useUserGroupMembership } from "../../../../../src/features/auth/logic/rbac";


const FrmdAdminCaseReviewStage: React.FC = () => {
  const { isFrmdAdmin } = useUserGroupMembership();

  const stageConfig = useAppSelector(selectStageConfigByStage(CaseStageEnum.FRMD_ADMIN_CASE_REVIEW));

  const currentStage = useAppSelector(selectCurrentCaseStage);

  const notes = currentStage?.stage_data?.notes

  if (isFrmdAdmin) {
    return (
      <WorkflowStageBanner
        title="Review New Case Forwarded"
        description="A new case was forwarded. Accept, Reject or Return to request additional information, as required."
        actions={stageConfig?.actions}
        notes={notes}
      />
    );
  }

  return (
    <WorkflowStageInfoBanner
      title="Pending with FRMD Admin for Case Review"
    />
  );
};

export default FrmdAdminCaseReviewStage;
